import { render, staticRenderFns } from "./BCXMessengerOptionsPanel.vue?vue&type=template&id=dd86885c&scoped=true"
import script from "./BCXMessengerOptionsPanel.vue?vue&type=script&lang=ts"
export * from "./BCXMessengerOptionsPanel.vue?vue&type=script&lang=ts"
import style0 from "./BCXMessengerOptionsPanel.vue?vue&type=style&index=0&id=dd86885c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd86885c",
  null
  
)

export default component.exports